import React, { useContext, useEffect, useState } from "react";
import { ListingCard } from "shared-components/ViewFragments/SearchPage/ListingCard";
import { isBigCard } from "@Utils/Functions";
import { PropertyCardSkeleton } from "shared-components/Components/Property/PropertyCard/PropertyCardSkeleton";

import dynamic from "next/dynamic"
import { NoResults } from "./NoResults";
import { useFacebookPixel } from "shared-components/GlobalHooks/web/FacebookPixel.hook";
import { ipIsFromCountry } from "shared-components/Components/Banners/BannerArgentoInvest/web";
import { FiltersStateContext } from "shared-components/Contexts/Filters/context";
import Stack from "shared-components/Components/Stack/web";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import 'shared-components/ViewFragments/SearchResults/Sider/ActiveFiltersTags/styles.less';

//@ts-ignore
const BannerSponsorSilver = dynamic(() => import("shared-components/Components/Banners/SponsorSilver/web").then(mod => mod.BannerSponsorSilver), { ssr: false });

export const Listings = ({ data, loading = false, error, forceHideBanners = false }) => {
    const FP = useFacebookPixel();
    const { order } = useContext(FiltersStateContext);
    const { country_code } = useContext(ConfigStateContext);
    const screen = useBreakpoint();
    let fullData = []

    if (data?.searchFast?.data) {
        fullData = data?.searchFast?.data;
    } else if (data?.landingSeo?.data) {
        fullData = data?.landingSeo?.data;
    }

    const [showSilverBanners, setShowSilverBanners] = useState<boolean>(false)
    const shouldShowSilverBanner = () => Math.round(Math.random() * 100) <= 40
    const argentoSponsorBanner = [
        "https://cdn1.infocasas.com.uy/web/655cb10a8aae9_original_hsbc_premier_campana-no-residentes_infocasas_v1-720x120px_1.gif",
        "https://cdn1.infocasas.com.uy/web/655cb10a8b463_original_hsbc_premier_campana-no-residentes_infocasas_v1-720x120px_2.gif",
        "https://cdn1.infocasas.com.uy/web/655cb10ab7742_original_hsbc_premier_campana-no-residentes_infocasas_v1-720x120px_3.gif"
    ]
    const [isFromAr, setIsFromAr] = useState(false)

    const onClickBannerArgento = e => {
        if (data?.sponsorSilver) {
            FP.StandardEvent("sponsor_silver");
            if (e.ctrlKey || e.metaKey) return false;
        }
    };

    useEffect(() => {
        if (forceHideBanners == false) {
            setShowSilverBanners(shouldShowSilverBanner())
        } else {
            setShowSilverBanners(false)
        }
    }, [data]);

    useEffect(() => {
        //Temporary commented
        // ipIsFromCountry("AR")
        //     .then((res) => setIsFromAr(res))
    }, [])

    const printResults = (res) => {
        let holesPoints = 0
        return <>
        {res?.map((prop: any, i: number) => {
            const bigCard = isBigCard(prop.highlight, order.value, country_code)
            holesPoints += bigCard ? 1 : 1 //ambos valen 1. no quiero que se muestren más de 1 banner por página
            const couldPrintBanner = holesPoints % 12 == 0 // mod 12 es la cantidad de puntos en 4 filas (3 huecos x 4 filas)
            const randomBanner = Math.floor(Math.random() * argentoSponsorBanner.length);

                // if(prop.duplicated?.length > 0) {
                //     const duplicated = [...prop.duplicated];
                //     return <Stack initialStack={duplicated.reverse().map((e,i)=>(
                //         <React.Fragment key={`lc-card-${i}`}>
                //             <ListingCard data={e} preloadImg={i < 3} />
                //         </React.Fragment>
                //     ))} />
                // }
                return (
                    <React.Fragment key={`lc-card-${prop.id}-${i}`}>
                        <div style={{width: "100%"}}>
                            <ListingCard showDuplicated={true} data={prop} preloadImg={i < 3} />
                        </div>
                        
                        {(couldPrintBanner && i === 2 && isFromAr) ?
                            <a
                                href={"https://www.hsbcdigital.com.uy/MainContact/?utm_source=1&utm_medium=4&utm_campaign=1&utm_term=4&utm_content=1"}
                                target="_blank"
                                onClick={onClickBannerArgento}
                                rel="nofollow"
                                className={"sponsor-silver-banner"}
                            >
                                <img src={argentoSponsorBanner[randomBanner]} alt={"HSBC"} />
                            </a> :
                            (couldPrintBanner && i != 0 && i < res?.length - 1 && showSilverBanners) ? <BannerSponsorSilver /> : null
                        }
                    </React.Fragment>
                )
            })
        }</>
    }

    const bigSkeleton = country_code !== 'CO' && screen.lg;
    return <>
        {!fullData && fullData.length == 0
            ? <NoResults />
            : <>
                <section className="listingsWrapper">
                    {loading && [...Array(4)].map((_, i) => <div className={'listingCard ' + (bigSkeleton ? 'isBigCard' : '')} key={i}><PropertyCardSkeleton big={bigSkeleton} /></div>)}
                    {!loading && fullData && printResults(fullData)}
                </section>
            </>
        }
    </>
}
